import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@material-ui/core';

const SessionTimeoutDialog = () => {
  const [open, setOpen] = useState(false);
  const sessionTimeout = JSON.parse(sessionStorage.getItem('session_timeout'));

  useEffect(() => {
    if (sessionTimeout) {
      sessionStorage.removeItem('session_timeout');
      setOpen(true);
    }
  }, [sessionTimeout]);

  return (
    <div>
      <Dialog open={open}>
        <DialogContent>
          <DialogContentText>
            You have been logged out due to inactivity.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="primary">
              OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default SessionTimeoutDialog;